import actionCreatorFactory from 'typescript-fsa';
import * as type from '../types/homemade';
var actionCreator = actionCreatorFactory();
export var requestHomemadeCategories = actionCreator(type.REQUEST_HOMEMADE_CATEGORY);
export var successHomemadeCategories = actionCreator(type.SUCCESS_HOMEMADE_CATEGORY);
export var failureHomemadeCategories = actionCreator(type.FAILURE_HOMEMADE_CATEGORY);
export var requestHomemadeCategoryDetail = actionCreator(type.REQUEST_HOMEMADE_CATEGORY_DETAIL);
export var successHomemadeCategoryDetail = actionCreator(type.SUCCESS_HOMEMADE_CATEGORY_DETAIL);
export var failureHomemadeCategoryDetail = actionCreator(type.FAILURE_HOMEMADE_CATEGORY_DETAIL);